<div class="datepicker-form" [formGroup]="form" (focusin)="onFocusIn($event)" (focusout)="onFocusOut($event)">
  <input class="datepicker-input" matInput [placeholder]="placeholder" readonly (click)="datePicker.open()" formControlName="dateStr" />
  <input class="datepicker-shadow-input" 
    [matDatepicker]="datePicker" 
    formControlName="date"
    [max]="max"
    [min]="min"
    (dateChange)="onDateChange()" />
  <mat-datepicker #datePicker></mat-datepicker>
</div>